export default __webpack_public_path__ + "static/media/imagem.fe0adc09.svg";